import { FC, ReactNode } from "react";

export interface FormSectionProps {
  id: string;
  number?: number;
  title: string;
  description?: string;
  ariaLabel?: string;
  className?: string;
  children: ReactNode;
}

export const FormSection: FC<FormSectionProps> = ({
  id,
  number,
  title,
  description,
  ariaLabel,
  className = "",
  children,
}) => (
  <section
    id={id}
    data-form-section
    data-form-section-title={title}
    data-form-section-number={number}
    aria-label={ariaLabel ?? title}
    className={`card border-0 shadow-sm bg-white blanket-form-section ${className}`.trim()}
  >
    <header className="card-header bg-white border-bottom d-flex align-items-start gap-3 py-3">
      {number !== undefined && (
        <span
          aria-hidden="true"
          className="blanket-section-number rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0"
        >
          {number}
        </span>
      )}
      <div>
        <h2 className="h6 fw-semibold mb-0">{title}</h2>
        {description ? (
          <p className="small text-muted mb-0 mt-1">{description}</p>
        ) : null}
      </div>
    </header>
    <div className="card-body">{children}</div>
  </section>
);

export default FormSection;
